define([
    'backbone',
    'handlebars',
    'modules/common/controls/select2'
], (Backbone, Handlebars, Select2) => Select2.extend({

    defaults: _.extend({
        smallSelection: false
    }, Select2.prototype.defaults),

    initialize () {
        _.extend(this.options, {
            text: 'display_name'
        });

        Select2.prototype.initialize.apply(this, arguments);
    },

    formatSelection (state) {
        const icon = Handlebars.helpers.h_channel_img(state.id);
        return this.options.smallSelection ? icon : '{0} {1}'.format(icon, state.display_name);
    },

    formatResult (state) {
        return '{0} {1}'.format(Handlebars.helpers.h_channel_img(state.id), state.display_name);
    }

}));
